import React, { createContext, useState, useEffect, useMemo } from "react";
import axios from "axios";
import PropTypes from "prop-types";

const ModerationCountContext = createContext({});

export const ModerationCountProvider = ({ children }) => {
  const [totalModeration, setTotalModeration] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/moderation`, {
          headers: {
            Authorization: `${token}`,
          },
        })
        .then((response) => {
          setTotalModeration(response.data.results);
        })
        .catch((error) => {
          console.error("Error fetching flagged items count:", error);
        });
    }
  }, []);

  const contextValue = useMemo(() => ({ totalModeration }), [totalModeration]);

  return (
    <ModerationCountContext.Provider value={contextValue}>
      {children}
    </ModerationCountContext.Provider>
  );
};

ModerationCountProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export {ModerationCountContext};


